// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentEventData$OrcaPaymentPage from "../../shared-code/sdk-utils/events/PaymentEventData.bs.js";

function useEmitCardState(cardNumber, cardExpiry, cvcNumber, cardBrand, complete, empty, isCardValid, isExpiryValid, isCvcValid, emitRawCardNumberOpt) {
  let emitRawCardNumber = emitRawCardNumberOpt !== undefined ? emitRawCardNumberOpt : false;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match.parentURL;
  let cardInfo = React.useMemo(() => PaymentEventData$OrcaPaymentPage.buildCardInfo(cardNumber, cardExpiry, cvcNumber, cardBrand), [
    cardNumber,
    cardExpiry,
    cvcNumber,
    cardBrand
  ]);
  React.useEffect(() => {
    let fieldStatus = Object.fromEntries([
      [
        "complete",
        complete
      ],
      [
        "empty",
        empty
      ],
      [
        "isCvcEmpty",
        cvcNumber === ""
      ],
      [
        "isCvcComplete",
        cardInfo.isCvcComplete
      ],
      [
        "isCardValid",
        Core__Option.getOr(isCardValid, false)
      ],
      [
        "isExpiryValid",
        Core__Option.getOr(isExpiryValid, false)
      ],
      [
        "isCvcValid",
        Core__Option.getOr(isCvcValid, false)
      ],
      [
        "hasCardValidationStatus",
        Core__Option.isSome(isCardValid)
      ],
      [
        "hasExpiryValidationStatus",
        Core__Option.isSome(isExpiryValid)
      ],
      [
        "hasCvcValidationStatus",
        Core__Option.isSome(isCvcValid)
      ]
    ]);
    let stateEntries = [
      [
        "cardBrand",
        cardBrand
      ],
      [
        "fieldStatus",
        fieldStatus
      ],
      [
        "cardInfo",
        PaymentEventData$OrcaPaymentPage.cardInfoToJson(cardInfo)
      ]
    ];
    let stateEntries$1 = emitRawCardNumber ? stateEntries.concat([[
          "rawCardNumber",
          cardNumber
        ]]) : stateEntries;
    Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
        "cardStateUpdate",
        Object.fromEntries(stateEntries$1)
      ]]);
  }, [
    cardInfo,
    cardBrand,
    cardNumber,
    complete,
    empty,
    cvcNumber,
    isCardValid,
    isExpiryValid,
    isCvcValid,
    emitRawCardNumber
  ]);
  return cardInfo;
}

function reportValidationErrors(cardNumber, cardExpiry, cvcNumber, cardBrand, isCardSupported, isFormValid, setCardError, setExpiryError, setCvcError, localeString) {
  if (cardNumber === "") {
    setCardError(param => localeString.cardNumberEmptyText);
    Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
  } else if (!Core__Option.getOr(isCardSupported, true)) {
    if (cardBrand === "") {
      setCardError(param => localeString.enterValidCardNumberErrorText);
      Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
    } else {
      let brandError = localeString.cardBrandConfiguredErrorText(cardBrand);
      setCardError(param => brandError);
      Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", brandError);
    }
  }
  if (cardExpiry === "") {
    setExpiryError(param => localeString.cardExpiryDateEmptyText);
    Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
  }
  if (cvcNumber === "") {
    setCvcError(param => localeString.cvcNumberEmptyText);
    Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
  }
  if (!isFormValid) {
    return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
  }
}

export {
  useEmitCardState,
  reportValidationErrors,
}
/* jotai Not a pure module */
